"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _I18n = _interopRequireDefault(require("I18n"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _memoize = _interopRequireDefault(require("react-utils/memoize"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _sizes = require("HubStyleTokens/sizes");

var _tshirtSize = require("../utils/propTypes/tshirtSize");

var _Styles = require("../utils/Styles");

var _UIDialogButton = _interopRequireDefault(require("../dialog/UIDialogButton"));

var SIZE_OPTIONS = {
  sm: {
    size: _sizes.SMALL_CLOSE_BUTTON_SIZE,
    padding: 12
  },
  md: {
    size: _sizes.MEDIUM_CLOSE_BUTTON_SIZE,
    padding: 16
  },
  lg: {
    size: _sizes.MODAL_CLOSE_BUTTON_SIZE,
    padding: 20
  },
  xl: {
    size: _sizes.EXTRA_LARGE_CLOSE_BUTTON_SIZE,
    padding: 38
  }
};
var CloseButton = (0, _styledComponents.default)(_UIDialogButton.default).withConfig({
  displayName: "UICloseButton__CloseButton",
  componentId: "wqkqo1-0"
})(["position:absolute;right:", ";top:", ";width:", ";height:", ";color:", ";&::after{padding:", ";}"], _sizes.MODAL_CLOSE_BUTTON_OFFSET, _sizes.MODAL_CLOSE_BUTTON_OFFSET, function (_ref) {
  var size = _ref.size;
  return (0, _Styles.toPx)(size);
}, function (_ref2) {
  var size = _ref2.size;
  return (0, _Styles.toPx)(size);
}, function (_ref3) {
  var color = _ref3.color;
  return color;
}, function (_ref4) {
  var padding = _ref4.padding;
  return (0, _Styles.toPx)(padding);
});

var CloseIcon = _styledComponents.default.svg.withConfig({
  displayName: "UICloseButton__CloseIcon",
  componentId: "wqkqo1-1"
})(["color:inherit;display:block;flex-grow:1;"]);

var CloseIconInner = _styledComponents.default.path.withConfig({
  displayName: "UICloseButton__CloseIconInner",
  componentId: "wqkqo1-2"
})(["fill:currentColor;stroke:currentColor;stroke-width:2;"]);

var renderCloseIcon = (0, _memoize.default)(function () {
  return _react.default.createElement(CloseIcon, {
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement(CloseIconInner, {
    d: "M14.5,1.5l-13,13m0-13,13,13",
    transform: "translate(-1 -1)"
  }));
});

var UICloseButton = function UICloseButton(_ref5) {
  var className = _ref5.className,
      disabled = _ref5.disabled,
      size = _ref5.size,
      rest = (0, _objectWithoutProperties2.default)(_ref5, ["className", "disabled", "size"]);
  var sizeOptions = SIZE_OPTIONS[(0, _tshirtSize.toShorthandSize)(size)];
  return _react.default.createElement(CloseButton, Object.assign({}, rest, {
    "aria-label": _I18n.default.text('salesUI.UICloseButton.label'),
    className: (0, _classnames.default)('private-close__button', className),
    "data-action": "close",
    disabled: disabled,
    IconHolder: renderCloseIcon,
    padding: sizeOptions.padding,
    size: sizeOptions.size
  }));
};

UICloseButton.propTypes = {
  color: _propTypes.default.string,
  disabled: _propTypes.default.bool.isRequired,
  size: (0, _tshirtSize.propTypeForSizes)(['sm', 'md', 'lg', 'xl'])
};
UICloseButton.defaultProps = {
  disabled: false,
  size: 'lg'
};
UICloseButton.displayName = 'UICloseButton';
var _default = UICloseButton;
exports.default = _default;
module.exports = exports.default;